module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253064967_Acknowledgments#sec1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmt",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253064967_Introduction#sec2"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cn",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253064967_Chapter01#sec3"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Rooted: A Contingent Look at Polish Jews in the Late 1930s")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cn",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter02#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("In Exile: Debating Postwar Plans during an Uprooted Present, 1940–1943")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cn",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter03#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Negating This Diaspora: The World Jewish Congress and the Prioritization of Postwar Life in Palestine, 1942–1944")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cn",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter04#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Uncertain Citizenship: Anxious Postwar Returns to East Central Europe, 1945–1946")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cn",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter05#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "sptoc"
  }, [_vm._v("Uprooted: The “Miraculous” Remnant of Polish Jews Who Survived in the Soviet Union and Their Postwar Migrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmb",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253064967_Conclusion#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Postwar Life Is Elsewhere")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253064967_Bibliography#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253064967_Index#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a79ed30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253064967_Contents.vue
// module id = 75
// module chunks = 0